export default __webpack_public_path__ + "static/apartment_b.668fa84d08bf7013efab9e4a3bc4b5e9.png";